import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * Resolve $today / $yesterday / $clientId / $statusReportId inside strings, or recurse objects/arrays.
 */
export function resolveSupplementalPipelineVariables (value, context) {
  const { clientId, statusReportId } = context ?? {}

  if (value == null) return value

  if (typeof value === 'string') {
    if (value === '$today') return dayjs.utc().format('YYYY-MM-DD')
    if (value === '$yesterday') return dayjs.utc().subtract(1, 'day').format('YYYY-MM-DD')
    if (value === '$clientId') return clientId
    if (value === '$statusReportId') return statusReportId
    return value
  }

  if (Array.isArray(value)) {
    return value.map((v) => resolveSupplementalPipelineVariables(v, context))
  }

  if (typeof value === 'object') {
    const out = {}
    for (const [k, v] of Object.entries(value)) {
      out[k] = resolveSupplementalPipelineVariables(v, context)
    }
    return out
  }

  return value
}

function safeObjectInput (pipelineVariables) {
  return pipelineVariables && typeof pipelineVariables === 'object' && !Array.isArray(pipelineVariables)
    ? pipelineVariables
    : {}
}

/**
 * Variables for execute-data-pipeline: same shape as Denali reports — everything under `filters`.
 * Template keys + resolved tokens are merged with `clientIds` and `statusReportId` (context wins on duplicates).
 */
export function buildSupplementalPipelineExecuteVariables (pipelineVariables, context) {
  const resolved = resolveSupplementalPipelineVariables(safeObjectInput(pipelineVariables), context)
  return {
    filters: {
      ...resolved,
      ...(context?.clientId != null ? { clientIds: [context.clientId] } : {}),
      ...(context?.statusReportId != null ? { statusReportId: context.statusReportId } : {})
    }
  }
}

/**
 * Variables for invoke-smart-endpoint: flat object (no `filters` wrapper).
 * Template keys + resolved tokens are merged with `clientId` and `statusReportId`.
 */
export function buildSmartEndpointVariables (pipelineVariables, context) {
  const resolved = resolveSupplementalPipelineVariables(safeObjectInput(pipelineVariables), context)
  return {
    ...resolved,
    ...(context?.clientId != null ? { clientId: context.clientId } : {}),
    ...(context?.statusReportId != null ? { statusReportId: context.statusReportId } : {})
  }
}
